'use client';
import * as React from 'react';
import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import { Alert, Snackbar, SnackbarContent } from '@mui/material';
import theme from '../ThemeRegistry/theme';
import { getCookie, setCookie } from 'cookies-next';
import { format } from 'date-fns';

const getDismissedAlerts = (): string[] => {
  const dismissedAlertsValue = getCookie('dismissedAlerts');
  return dismissedAlertsValue
    ? (JSON.parse(dismissedAlertsValue) as string[])
    : [];
};

const renderNotification = (notification: {
  type: string;
  id: string;
  start: Date;
  end: Date;
}) => {
  console.log(
    notification,
    format(notification.start, 'p eeee do MMMM'),
    format(notification.end, 'p eee do MMMM')
  );
  switch (notification.type) {
    case 'maintenance':
      return `The Urban Developer will be undergoing scheduled maintenance from ${format(
        notification.start,
        'p eeee do MMMM'
      )} to ${format(notification.end, 'p eee do MMMM')}. Your patience is appreciated.`;
    default:
      return '';
  }
};

export const Notification = ({
  notification,
  message,
  location,
  style,
  alertId
}: NotificationProps) => {
  const [isClient, setIsClient] = useState(false);
  const [alertOpen, setAlertOpen] = useState(true);
  const dismissAlert = () => {
    const dismissedAlerts = getDismissedAlerts();
    setCookie('dismissedAlerts', [...dismissedAlerts, alertId]);

    setAlertOpen(!alertOpen);
  };

  const dismissAlertButton = (
    <Button
      size='small'
      onClick={() => dismissAlert()}
      style={{ color: theme.palette.primary.main }}
      sx={{ padding: '0.5rem 1rem' }}
    >
      Dismiss
    </Button>
  );

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return null;
  }

  return (
    <Snackbar open={alertOpen} anchorOrigin={location}>
      {style === 'default' ? (
        <SnackbarContent
          message={
            <div className='notificationAlert'>
              <div>
                {notification ? renderNotification(notification) : message}
              </div>
              {dismissAlertButton}
            </div>
          }
        />
      ) : (
        <Alert
          severity={style}
          className='notificationAlert'
          action={dismissAlertButton}
          onClose={() => dismissAlert()}
        >
          {notification ? renderNotification(notification) : message}
        </Alert>
      )}
    </Snackbar>
  );
};
